export default function hasPreview(file) {
  return file.hasOwnProperty('preview')
}



// WEBPACK FOOTER //
// ./src/utils/hasPreviewProperty.js